/**
 * 将秒数对齐到步长网格（步长为 0 则原样返回）。
 *
 * @param seconds - 时间（秒）
 * @param stepSec - 网格步长（秒）
 */
export function snapSecondsToStep(seconds: number, stepSec: number): number {
  const s = Number(stepSec)
  if (!Number.isFinite(s) || s <= 0) return seconds
  return Math.round(Number(seconds) / s) * s
}
